import React, { useState } from 'react';
import styles from './ImageSelect.module.scss';

interface Props {
	name: string;
	isRequired?: boolean;
	images: {
		key: string;
		value: string;
	}[];
}

const ImageSelect: React.FC<Props> = ({ name, isRequired, images }) => {
	const [selectedImage, setSelectedImage] = useState<string | undefined>(
		undefined,
	);
	return (
		<>
			<div className={styles.wrapper}>
				{images.map(item => (
					<img
						className={selectedImage === item.key ? styles.selected : ''}
						src={item.value}
						alt={item.key}
						onClick={() => setSelectedImage(item.key)}
						key={item.key}
					/>
				))}
			</div>
			<input
				style={{ display: 'none' }}
				type='text'
				value={selectedImage}
				name={name}
				required={isRequired}
			/>
		</>
	);
};

export default ImageSelect;
